
import {map} from 'rxjs/operators';
import {Component, OnInit} from '@angular/core';
import {ForgotPasswordService} from '../services/forgot-password.service';
import { IMyDpOptions,IMyDateModel } from 'mydatepicker';
import * as moment from 'moment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  public disableSince = {year: moment().year(), month: (moment().get('month')+1), day: moment().date()}
  public username:string;
  //public dateOfBirth = {year: moment().year(), month: (moment().get('month')+1), day: moment().date()}
  public dateOfBirth: Object = {};
  public dateOfBirthText;
  success;
  message;
  error;
  data;
  errorERRFP000001:any = false;
  errorERRFP000002;
  errorERRFP000003;
  errorERRFP000004;
  errorERRFP000005;
  errorMessage:string;
  public mask = [/[0-9]/, /\d/, '/', /\d/, /\d/,'/', /\d/, /\d/, /\d/, /\d/];
  public myDatePickerOptions:IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showTodayBtn: false,
    markCurrentDay: true,
    showSelectorArrow: true,
    showClearDateBtn : false,
    editableDateField : true,
    disableSince:this.disableSince
  };
  public formatedDob;
  constructor(private forgotPasswordService:ForgotPasswordService) {
    let showtimeoutClass = document.getElementsByClassName("showclass");
    if (showtimeoutClass.length > 0) {
      document.documentElement.className.replace(/(?:^|\s)showclass(?!\S)/, '');
      let timeOutClass = document.getElementById("sessionTimeoutModal");
      timeOutClass.className = '';
      timeOutClass.className += "hideClass";
    }
  }


  ngOnInit() {
  }

  public resetForgotPasswordErrors() {
    this.error = false;
    this.errorERRFP000001 = false;
    this.errorERRFP000002 = false;
    this.errorERRFP000003 = false;
    this.errorERRFP000004 = false;
    this.errorERRFP000005 = false;
  }

  forgotPassword() {
    this.forgotPasswordSet().subscribe();
  }

  forgotPasswordSet() {
    this.changeDateFormat();
    this.formatedDob = this.dateOfBirth;
     return this.forgotPasswordService.forgotPassword({
      username: this.username,
      dateOfBirth: this.formatedDob,
    }).pipe(map(
      data => {
        this.data = data;
        if (this.data.status == '200') {
          this.resetForgotPasswordErrors();
          this.success = true;
          this.message = this.data.message;
        } else {
          this.success = null;
          this.resetForgotPasswordErrors();
          if (this.data.status !== null || this.data.status !== undefined) {
            this['error' + this.data.status] = true;
            this.message = this.data.message;
          } else {
            this.error = 'ERROR';
            this.message = this.data.message;
          }
        }
      }, error => {
        this.success = null;
        this.error = 'ERROR';
      }));
  }
  onDateChanged(event){
   this.dateOfBirthText = event.formatted;
  }
  updateDatePicker(){
    let split = this.dateOfBirthText.split("/");
    let dd;
    if(split[0] != ''){
      dd = split[0].replace(/[^0-9]/g, '');
    }
    let mm;
    if(split[1] != ''){
       mm = split[1].replace(/[^0-9]/g, '');
    }

    let yyyy;
    if(split[2] != ''){
      yyyy = split[2].replace(/[^0-9]/g, '');
    }
    this.dateOfBirth = {
      date: {
        year: yyyy,
        month: mm.replace(/\b0+/g, ''),
        day: dd.replace(/\b0+/g, '')
      }
    };
  }
  changeDateFormat() {
    Object.keys(this.dateOfBirth).forEach(key => {
      if (key == 'date') {
        this.dateOfBirth = new Date(this.dateOfBirth[key].year, (this.dateOfBirth[key].month) - 1, this.dateOfBirth[key].day);
      }
    });
  }

}
